import { DateTime } from "luxon";
import store from "../store.js";
import { updateFormDigest } from "./sharepointAPI.js";

export type EnvironmentPaths = {
  baseUrl: string;
  listapi: string;
  webapi: string;
  vsdllistapi: string;
  env: string;
};

export const getEnvironment = () => {
  const pathTree = window.location.pathname.split("/");

  if (window.location.hostname === "localhost") {
    return "faq";
  } else {
    return pathTree[2].toLowerCase(); // returns either 'faq' or 'faqat'
  }
};

export const getEnvironmentPaths = (): EnvironmentPaths => {
  const paths = {
    baseUrl: "/tjansterprodukter/faq",
    listapi: "/tjansterprodukter/faq/_api/web/lists",
    webapi: "/tjansterprodukter/faq/_api/web",
    vsdllistapi: "/tjansterprodukter/vsdltest/_api/web/lists",
    env: "local" // prod, dev, local
  };

  if (window.location.href.includes("faqat")) {
    paths.baseUrl = "/tjansterprodukter/faqat";
    paths.listapi = "/tjansterprodukter/faqat/_api/web/lists";
    paths.webapi = "/tjansterprodukter/faqat/_api/web";
    paths.vsdllistapi = "/tjansterprodukter/vsdlat/_api/web/lists";
    paths.env = "dev";
  } else if (
    window.location.href.includes("logistikportalen") ||
    window.location.href.includes("logp")
  ) {
    paths.baseUrl = "/tjansterprodukter/faq";
    paths.listapi = "/tjansterprodukter/faq/_api/web/lists";
    paths.webapi = "/tjansterprodukter/faq/_api/web";
    paths.vsdllistapi = "/tjansterprodukter/vsdl/_api/web/lists";
    paths.env = "prod";
  }
  return paths;
};

export const getPlatform = () => {
  const storeData = store.getState();
  const isLoggedIn = storeData.application.isLoggedIn;
  return isLoggedIn;
};

export const keepSessionAlive = () => {
  setInterval(updateFormDigest, 10 * 60000);
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  return emailRegex.test(email);
};

export const truncateText = (text: string, maxCharacters: number) => {
  if (text?.length <= maxCharacters) {
    return text;
  } else {
    return text?.substring(0, maxCharacters) + "\u2026";
  }
};

export const formatUsername = (username: string | null): string => {
  if (!username) return "";
  return username
    .trim()
    .replace(/^([\wÀ-ÿ\-']+),\s+([\wÀ-ÿ\-']+)\s+ex\w{4}$/i, "$2 $1");
};

export function formatFileName(originalName: string) {
  // 1. Find the extension by looking for the last '.' character.
  const lastDotIndex = originalName.lastIndexOf(".");
  let nameWithoutExt = originalName;
  let extension = "";

  if (lastDotIndex !== -1) {
    nameWithoutExt = originalName.slice(0, lastDotIndex);
    extension = originalName.slice(lastDotIndex); // includes the dot, e.g. ".png"
  }

  // 2. Sanitize the part before the extension (replace spaces, special chars, etc.).
  const sanitizedName = nameWithoutExt.replace(/[^a-zA-Z0-9_-]/g, "_");

  // 3. Optionally handle duplicates if needed, but append the extension back.
  return `${sanitizedName}${extension}`;
}

export const generateFileName = (fileName: string) => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1; //zero-indexed
  const day = currentDate.getDate();
  const hour = currentDate.getHours() + 1;
  const minute = currentDate.getMinutes() + 1;
  const dateString = year + "_" + month + "_" + day + "_" + hour + "_" + minute;
  let newFileName = fileName.replace(/\.[0-9a-z]+$/i, "");
  const extension = fileName.match(/\.[0-9a-z]+$/i);
  newFileName = newFileName.replace(/[^a-z0-9.]/gi, "_"); // replace special characters with _
  newFileName += "_" + dateString;
  newFileName += extension;
  return newFileName;
};

export function isLocalhost() {
  return window.location.hostname === "localhost";
}

export function ensureHttpPrefix(link: string) {
  if (!link) return "";

  // Check if the string starts with 'http://' or 'https://'
  if (link.startsWith("http://") || link.startsWith("https://")) {
    return link;
  } else {
    return `https://${link}`;
  }
}

export function downloadDraftFile(file: { preview: string; type: string }) {
  const link = document.createElement("a");
  link.href = file.preview;
  link.download = file.type;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function userTitleToFullName(title: string) {
  const splitName = title.split(",");

  if (splitName.length === 1) {
    return title;
  } else {
    const name = splitName[1].split(" ")[1] + " " + splitName[0];
    return name;
  }
}

export function formatDateTime(
  date: string | null | undefined,
  fallbackProperty: string | undefined
): string {
  const format = "yyyy-LL-dd HH:mm";

  if (date) {
    return DateTime.fromISO(date).toFormat(format);
  } else if (fallbackProperty) {
    return DateTime.fromISO(fallbackProperty).toFormat(format);
  } else {
    return "Information saknas";
  }
}
export const downloadFile = (file: any, listName: string) => {
  let siteUrl = "";
  let downloadUrl;
  try {
    siteUrl = file.__metadata.uri.split("/_api/")[0];
    downloadUrl =
      siteUrl +
      "/_layouts/download.aspx?SourceUrl=" +
      siteUrl +
      "/" +
      listName +
      "/" +
      file.Title;
    window.location.href = downloadUrl;
    return downloadUrl;
  } catch {
    ("file metadata missing");
  }
};
